jQuery(document).ready(function ($) {
    'use strict';

    $(document.body).on('click', '.toggle-button', function() {

        $(this).toggleClass('active');
        $(this).next('.toggle-element').toggle();

    });

});
//# sourceMappingURL=toggle.js.map
